/* Keep one schema owner while retaining a server-rendered theme fallback. */
(() => {
  const read = (script) => {
    try { return JSON.parse(script.textContent); } catch { return null; }
  };
  const nodes = (value) => {
    if (Array.isArray(value)) return value.flatMap(nodes);
    if (!value || typeof value !== 'object') return [];
    return value['@graph'] ? nodes(value['@graph']) : [value];
  };
  const isType = (node, expected) => {
    const types = [].concat(node['@type'] || []);
    return expected === 'Article'
      ? types.some((type) => type === 'Article' || type === 'BlogPosting')
      : types.includes(expected);
  };
  const canonical = document.querySelector('link[rel="canonical"]')?.href;
  const samePage = (node) => {
    const entity = node.mainEntityOfPage;
    const address = node.url || (typeof entity === 'string' ? entity : entity?.['@id']) || node['@id'];
    if (!address || !canonical) return true;
    try {
      const url = new URL(address, canonical);
      url.hash = '';
      return url.href === canonical;
    } catch { return false; }
  };
  const sync = () => {
    const vendors = Array.from(document.querySelectorAll('script[author="tpt"][type="application/ld+json"]'))
      .map((script) => ({ script, data: read(script) })).filter((entry) => entry.data);
    document.querySelectorAll('script[data-petjew-schema]').forEach((source) => {
      const desired = read(source);
      const type = source.dataset.petjewSchema;
      if (!desired || !['Article', 'BreadcrumbList'].includes(type)) return;
      let owner = null;
      let target = null;
      for (const vendor of vendors) {
        const match = nodes(vendor.data).find((node) =>
          isType(node, type) && (type !== 'Article' || samePage(node)));
        if (match) { owner = vendor; target = match; break; }
      }
      if (!owner) {
        if (source.type !== 'application/ld+json') source.type = 'application/ld+json';
        return;
      }
      const fields = type === 'BreadcrumbList' ? ['itemListElement'] :
        ['headline', 'description', 'datePublished', 'dateModified', 'author', 'image', 'mainEntityOfPage'];
      let changed = false;
      fields.forEach((field) => {
        if (desired[field] !== undefined && JSON.stringify(target[field]) !== JSON.stringify(desired[field])) {
          target[field] = desired[field];
          changed = true;
        }
      });
      if (changed) owner.script.textContent = JSON.stringify(owner.data);
      // Tapita remains the indexed owner; retain the theme data without a second JSON-LD block.
      if (source.type !== 'application/json') source.type = 'application/json';
    });
  };
  const start = () => {
    sync();
    let pending = false;
    const isVendor = (node) => node.nodeType === 1 && node.matches('script[author="tpt"]');
    new MutationObserver((records) => {
      const relevant = records.some((record) => isVendor(record.target) ||
        Array.from(record.addedNodes).some((node) => isVendor(node) ||
          (node.nodeType === 1 && node.querySelector('script[author="tpt"]'))));
      if (!relevant || pending) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; sync(); });
    }).observe(document.head, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();